import React, { useState, useEffect } from 'react';
import { Form } from 'formik';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import '../../../../containers/UserKyc/AadharPage/Aadhar.css';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import InputTypeNumber from '../../../../common/components/InputTypeNumber/InputTypeNumber';
import './HomeLoanDetails.css';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
const HomeLoanDetails = props => {
  const [checked, setChecked] = useState(false);
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [show, setShow] = useState(true);
  const [leadAppicant_Id, setLeadApplicant_Id] = useState('');
  const [lead_Id, setLead_id] = useState('');
  const [hasSanctionDoc, setHasSanctionDoc] = useState('');
  const [hasStatementDoc, setHasStatementDoc] = useState('');
  const [editStatement, setEditStatement] = useState(false);
  const [editSanction, setEditSanction] = useState(false);

  const {
    values,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    setFieldTouched,
    handleSubmit,
    isSubmitting,
    setStatementDocId,
    setSactionDocId,
    getSavedData,
    setUpdateAPI,
    setLoanId,
    wizardValues
  } = props;
  const [loading, setLoading] = useState(false);
  const [mobile, setMobile] = useState('');
  const inputLength = mobile.length;
  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
    return () => {};
  }, []);
  useEffect(() => {
    if (getSavedData.length > 0) {
      setFieldValue('id', getSavedData[0].id);
      setFieldValue('lender', getSavedData[0].lender);
      setFieldValue('propertyValue', getSavedData[0]?.propertyValue);
      setFieldValue('interestRate', getSavedData[0]?.interestRate);
      setFieldValue('sanctionAmount', getSavedData[0]?.sanctionAmount);
      setFieldValue('balanceAmount', getSavedData[0]?.balanceAmount);
      setFieldValue('currentEmi', getSavedData[0]?.currentEmi);
      setFieldValue('totalTenure', getSavedData[0]?.totalTenure);
      setFieldValue('balanceTenure', getSavedData[0]?.balanceTenure);
      if (getSavedData[0]?.sanctionDoc != null) {
        setHasSanctionDoc(getSavedData[0]?.sanctionDoc?.links[0]?.url);
        setSactionDocId(getSavedData[0]?.sanctionDoc?.links[0]?.docId);
      }
      if (getSavedData[0]?.statementDoc != null) {
        setHasStatementDoc(getSavedData[0]?.statementDoc?.links[0]?.url);
        setStatementDocId(getSavedData[0]?.statementDoc?.links[0]?.docId);
      }
      setUpdateAPI(true);
      setLoanId(getSavedData[0].id);
    } else {
      setFieldValue('lender', '');
      setFieldValue('propertyValue', '');
      setFieldValue('sanctionAmount', '');
      setFieldValue('balanceAmount', '');
      setFieldValue('currentEmi ', '');
      setFieldValue('interestRate ', '');
      setFieldValue('totalTenure', '');
      setFieldValue('balanceTenure', '');
    }
  }, []);
  return (
    <React.Fragment>
      <Form onSubmit={handleSubmit} className="w-full">
        <div className="bg-white py-8 md:py-1 p-2 ">
          <div className="flex-1  w-full">
            <p className="font-roboto font-normal text-black-400 text-base py-2">
              Current Obligation
            </p>
            <p className="font-roboto font-normal text-green-900 text-base py-2">
              Loan
            </p>
            <div className="block">
              <div className="w-full md:flex block">
                <div className="w-full md:w-6/12 md:pt-9 py-3 ">
                  <CommonInput
                    name="lender"
                    disabled={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.lender}
                    legendName="Lender Name"
                    error={touched.lender && errors.lender}
                    errorMsg={errors.lender}
                    touched={touched.lender}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                  />
                </div>
                <div className="w-full md:w-6/12 md:pt-9 py-3 mr-auto md:ml-7 ">
                  <InputTypeNumber
                    name="propertyValue"
                    maxLength={10}
                    minLength={0}
                    legendName={'Approx Market Value of Property'}
                    value={values.propertyValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={false}
                    error={touched.propertyValue && errors.propertyValue}
                    errorMsg={errors.propertyValue}
                    touched={touched.propertyValue}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showInText={false}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                  />
                </div>
              </div>
              <div className="md:flex block overflow-hidden">
                <div className="w-full md:w-6/12 float-left py-3">
                  <InputTypeNumber
                    name="sanctionAmount"
                    maxLength={10}
                    minLength={0}
                    legendName={'Sanction Amount'}
                    value={values.sanctionAmount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={false}
                    error={touched.sanctionAmount && errors.sanctionAmount}
                    errorMsg={errors.sanctionAmount}
                    touched={touched.sanctionAmount}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showInText={false}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                  />
                </div>
                <div className="w-full md:w-6/12 float-left md:ml-7 py-3">
                  <InputTypeNumber
                    name="balanceAmount"
                    maxLength={10}
                    minLength={0}
                    legendName={'Balance Amount'}
                    value={values.balanceAmount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={false}
                    error={touched.balanceAmount && errors.balanceAmount}
                    errorMsg={errors.balanceAmount}
                    touched={touched.balanceAmount}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showInText={false}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                  />
                </div>
              </div>
              <div className="w-full md:flex block ">
                <div className="w-full md:w-6/12 py-3">
                  <CommonInput
                    name="totalTenure"
                    disabled=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.totalTenure}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Total Tenure in Months"
                    error={touched.totalTenure && errors.totalTenure}
                    errorMsg={errors.totalTenure}
                    touched={touched.totalTenure}
                  />
                </div>
                <div className="w-full md:w-6/12 md:ml-7 py-3">
                  <CommonInput
                    name="balanceTenure"
                    disabled=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.balanceTenure}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Balance Tenure in Months"
                    error={touched.balanceTenure && errors.balanceTenure}
                    errorMsg={errors.balanceTenure}
                    touched={touched.balanceTenure}
                  />
                </div>
              </div>
              <div className="w-full md:flex block">
                <div className="w-full md:w-6/12 py-3">
                  <CommonInput
                    name="interestRate"
                    disabled=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.interestRate}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%'
                    }}
                    legendName="Current Rate of Interest"
                    error={touched.interestRate && errors.interestRate}
                    errorMsg={errors.interestRate}
                    touched={touched.interestRate}
                  />
                </div>
                <div className="w-full md:w-6/12 md:ml-7 py-3">
                  {wizardValues?.ChooseLoanPurpose?.loneTypeID == 11 ? (
                    <InputTypeNumber
                      name="topUpAmount"
                      maxLength={10}
                      minLength={0}
                      legendName={'Top Up Amount'}
                      value={values.topUpAmount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={false}
                      error={touched.topUpAmount && errors.topUpAmount}
                      errorMsg={errors.topUpAmount}
                      touched={touched.topUpAmount}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      showInText={false}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                    />
                  ) : null}
                </div>
              </div>
              <div className="w-full md:flex block ">
                <div className="w-full md:w-6/12 md:ml-7 py-3">
                  <div className="hidden">
                    <CommonInput
                      name="id"
                      disabled={true}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.id}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                      legendName="id"
                      error={touched.id && errors.id}
                      errorMsg={errors.id}
                      touched={touched.id}
                    />
                  </div>
                </div>
              </div>
              <div className="md:flex block sm:py-5">
                {hasSanctionDoc != '' && !editSanction ? (
                  <div className={`w-full md:w-5/12 py-3 upload_loan`}>
                    <p className="font-roboto font-normal text-grey-920 text-base py-3 text-center">
                      Loan Sanction Letter
                    </p>

                    <ShowGetImage
                      img={hasSanctionDoc}
                      setEdit={setEditSanction}
                      editBtn={false}
                    />
                  </div>
                ) : null}
                {hasStatementDoc != '' && !editStatement ? (
                  <div className={`w-full md:w-5/12 py-3 upload_loan md:ml-5`}>
                    <p className="font-roboto font-normal text-grey-920 text-base py-3 text-center">
                      Loan Statement
                    </p>
                    <ShowGetImage
                      img={hasStatementDoc}
                      setEdit={setEditStatement}
                      editBtn={false}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </Form>
    </React.Fragment>
  );
};
export default HomeLoanDetails;
